<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <ThinkingView :parent.sync="form" :children.sync="form.posts" :addButtonName="`添加岗位`" :addElement="addPost" :deleteElement="deletePost" lineText="所需岗位">
        <template slot="leftBox" slot-scope="scope">
          <el-form>
            <el-form-item label="行业名称">
              <el-input v-model="scope.data.name" placeholder="行业名称" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="行业描述">
              <el-input v-model="scope.data.intro" type="textarea" placeholder="行业描述" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="可使用类型">
              <el-radio-group v-model="scope.data.canUse">
                <el-radio :label="0">免费</el-radio>
                <el-radio :label="1">VIP</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </template>
        <template slot="rightBox" slot-scope="scope">
          <div style="margin-right: 10px; width: 100px;">
            <positionSelection v-model="scope.data.certId" />
          </div>
          <el-input size="small" type="textarea" :rows="2" v-model="scope.data.jobDesc" :placeholder="`描述该岗位在当前行业的职责`"
              :clearable="true"></el-input>
        </template>
      </ThinkingView>
      <!-- 岗位 -->
      <el-form-item label="需求校验信息">
        <div v-for="(slot, index) in form.checkSlots" :key="index" class="post-list">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-input v-model="slot.name" placeholder="名称"></el-input>
            </el-col>
            <el-col :span="4">
              <el-select v-model="slot.type" placeholder="类型">
                <el-option label="字符串" value="string"></el-option>
                <el-option label="数字" value="number"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10">
              <el-input v-model="slot.description" placeholder="描述"></el-input>
            </el-col>
            <el-col :span="2">
              <el-checkbox v-model="slot.required">必需</el-checkbox>
            </el-col>
            <el-col :span="2">
              <el-button type="danger" icon="el-icon-delete" @click="deleteCheckSlot(index)" size="mini"></el-button>
            </el-col>
          </el-row>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click="addCheckSlot" size="mini" style="margin-top:10px;">添加校验槽</el-button>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
      <el-button type="success" size="small" icon="el-icon-circle-check" @click="confirm('form')">保存</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  updateAgentIndustry,
  getAgentIndustryDetail
} from '@/api/merchant/agent'
import PositionSelection from '@/components/project/PositionSelection.vue'
import ThinkingView from '@/components/chat/ThinkingView.vue'
export default {
  name: 'editAgentIndustry',
  components: {
    PositionSelection,
    ThinkingView
  },
  data () {
    return {
      id: '', // id
      form: {
        name: '', // 名称
        intro: '', // 描述
        posts: [], // 岗位
        canUse: 0, // 可使用类型，0免费，1VIP
        checkSlots: [] // 校验槽
      },
      replyOptionLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.id = that.$route.query.id
    console.log(that.id, 'id')
    if (that.id != null) {
      that.getInfo(that.id)
    }
  },
  beforeDestroy () {
  },
  methods: {
    addPost () {
      this.form.posts.push({
        certId: '',
        jobDesc: ''
      })
      this.$nextTick(this.updateLines)
    },
    deletePost (index) {
      this.form.posts.splice(index, 1)
      this.$nextTick(this.updateLines)
    },
    addCheckSlot () {
      console.log(this.form.checkSlots, 'checkSlots')
      if (!this.form.checkSlots) {
        this.form.checkSlots = []
      }
      this.form.checkSlots.push({
        name: '',
        type: '',
        description: '',
        required: false
      })
      // 强制刷新
      this.$forceUpdate()
    },
    deleteCheckSlot (index) {
      this.form.checkSlots.splice(index, 1)
    },
    getInfo (id) {
      let that = this
      getAgentIndustryDetail(id).then(res => {
        // 只替换已有字段，保持响应式
        Object.assign(that.form, res)
        // 如果后端没有返回 checkSlots 字段，确保它是数组
        if (!that.form.checkSlots) {
          that.form.checkSlots = []
        }
      })
    },
    confirm () {
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    // 编辑
    getModify (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        updateAgentIndustry(that.id, that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
          // that.$router.push("/demo/helper/keyword");
        })
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 20px;
}

.post-list {
  margin-bottom: 10px;
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 5px;
}
</style>
